import { render, staticRenderFns } from "./SocksProxyForm.vue?vue&type=template&id=fd77d8e4&scoped=true"
import script from "./SocksProxyForm.vue?vue&type=script&lang=js"
export * from "./SocksProxyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd77d8e4",
  null
  
)

export default component.exports